import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';

import { COLORS, BOX_SHADOW } from '@/constants';

const expansionPanelBorderRadius = { borderRadius: 0 };

const StyledAccordionFaq = styled(Accordion)({
  '&.MuiPaper-root': {
    boxShadow: BOX_SHADOW.DEFAULT,
    '&:hover': {
      boxShadow: BOX_SHADOW.HOVER,
    },
    '&.Mui-expanded': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },

  '&.rounded:last-child': {
    borderRadius: 0,
  },
});

const StyledAccordionSummaryFaq = styled(AccordionSummary)(({ theme }) => ({
  '&.MuiAccordionSummary-root': {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 48,
    margin: 0,

    '&:hover': {
      backgroundColor: COLORS.GREY_FOUR,
      boxShadow: `inset 0 0 0 2px ${COLORS.BRAND_BLUE_SIX}`,
      borderRadius: 1,
    },

    '.MuiSvgIcon-root': {
      fontSize: 44,
      [theme.breakpoints.down('sm')]: {
        fontSize: 36,
      },
    },

    [theme.breakpoints.down('sm')]: {
      paddingRight: 24,
    },

    '.MuiAccordionSummary-content': {
      margin: 0,
    },
  },
}));

const StyledAccordionDetails = styled(AccordionDetails)({
  '&.MuiAccordionDetails-root': {
    padding: 0,
  },
});

const DividerFaq = styled('div')({
  height: 3,
  backgroundColor: COLORS.GREY_THREE,
});

const Divider = styled('div')({
  height: 3,
  backgroundColor: COLORS.GREY_FOUR,
});

export {
  expansionPanelBorderRadius,
  StyledAccordionFaq,
  StyledAccordionSummaryFaq,
  StyledAccordionDetails,
  DividerFaq,
  Divider,
};
